import React from 'react'
import { alternativePaymentsLogoSvg } from './svgs'

type LogoColor = 'light' | 'dark'

export interface AlternativePaymentsLogoProps {
  color?: LogoColor
  height?: number
  width?: number
}

const COLORS: Record<LogoColor, string> = {
  light: '#FFFFFF',
  dark: '#1D1D1B'
}

export const AlternativePaymentsLogo: React.FC<
  AlternativePaymentsLogoProps
> = ({ color = 'dark', height = 45, width = 124 }) => (
  <svg
    aria-labelledby='alternative-payments-logo'
    role='img'
    viewBox='0 0 164 45'
    height={height}
    width={width}
    fill={COLORS[color]}
  >
    <title id='alternative-payments-logo'>Alternative Payments</title>
    {alternativePaymentsLogoSvg.map(svg => (
      <path {...svg} key={svg.d} />
    ))}
  </svg>
)
